import { combineReducers } from 'redux';

import ids from './ids';
import isReady from './isReady';
import page from './page';
import sort from './sort';

/**
 * @typedef {{
 *  ids: import('./ids').State,
 *  sort : import('./sort').State,
 *  page: import('modules/global/generic.types').Page,
 *  isReady: import('./isReady').State,
 * }} DashboardState
 */

export default combineReducers({
  isReady,
  ids,
  sort,
  page,
});
